import type { AppConfig } from "@edreamsodigeo/frontend-app-config";

import type { AppProviderProps } from "../app/AppProvider";
import { createAppProviderCoreProps } from "../app/createAppProviderCoreProps";
import { pageTracker } from "../integration/frontend-tracking-agent";
import type { MicroFrontEndConfig } from "./MFEPageProvider";

type EmptyString = "";
type LegacyProps =
  | "children"
  | "errorHandler"
  | "logger"
  | "pageHandler"
  | "flowActions"
  | "routerPush"
  | "routeMatcher";

export type MicroFrontendProps = Omit<AppProviderProps, LegacyProps>;

const i18nextOptions = {
  parseMissingKeyHandler: (): EmptyString => "",
};

export const getMicroFrontendProps = (
  appConfig: AppConfig,
  mfe?: MicroFrontEndConfig,
): MicroFrontendProps => {
  const {
    site,
    brand,
    locale,
    featuresResult,
    clientInterface,
    context,
    flow,
    facebookId,
    googleClientId,
    marketingPortal,
    isMeta,
  } = appConfig;

  const {
    storageClient,
    customDimensionsRepository,
    datalayerTrackingClient,
    eCommerceTrackingClient,
    trackingParamsRepository,
    dataMeshTrackingClient,
    thirdPartyTrackingAgent,
  } = createAppProviderCoreProps({
    brandCode: brand,
    locale,
    trackingAgent: {
      trackPage: () => {}, // TODO: deprecated prop. tracking-agent will do it itself.
      trackSurvey: () => {}, // TODO: deprecated prop. tracking-agent will do it itself.
      routeMatcher: {
        getPathParams: () => ({}),
        findMatchingPattern: () => "",
      }, // TODO: deprecated prop.
      routePageMap: {}, // TODO: deprecated prop.
    },
    mfe,
  });

  return {
    site,
    brand,
    featuresResult,
    clientInterface,
    context,
    locale: locale.i18n,
    dateLocale: locale.dates,
    currencyLocale: locale.currency,
    currencyFormat: locale.currencyFormat,
    i18nextOptions,
    storageClient,
    pageTracker,
    customDimensionsRepository,
    datalayerTrackingClient,
    eCommerceTrackingClient,
    trackingParamsRepository,
    dataMeshTrackingClient,
    thirdPartyTrackingAgent,
    flow,
    facebookId,
    googleClientId,
    marketingPortal,
    isMeta,
  };
};
